<template>
  <div class="page publish-at">
    <header class="at-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/pt/exercise-center' }"
          >共性分析</el-breadcrumb-item
        >
        <el-breadcrumb-item>布置薄弱知识点训练22</el-breadcrumb-item>
      </el-breadcrumb>
      <card-header class="mt-20">布置薄弱知识点训练</card-header>
    </header>
    <div class="hr mt-20"></div>
    <el-form class="mt-40" label-width="110px">
      <el-form-item
        :label="`练习知识点（共${this.checkedWeakPointList.length}个）：`"
        class="knowledge-content"
      >
        <div class="knowledge-name">
          <el-tag
            v-for="(name, index) in checkedWeakPointList"
            :key="index"
            type="info"
            size="small"
            closable
            @close="handleClose(name)"
          >
            {{ name.tag_name }}
          </el-tag>
        </div>
      </el-form-item>
      <el-form-item label="每个知识点练习题量" required class="knowledge-count">
        <div class="control-number">
          <div
            class="btn"
            @click="decrease"
            :class="{ disabled: searchForm.number <= 1 }"
          >
            <i class="el-icon-minus"></i>
          </div>
          <input
            type="text"
            ref="input"
            max="10"
            min="1"
            readonly="readonly"
            class="question-num-input"
            placeholder="请填写"
            v-model="searchForm.number"
          />
          <div
            class="btn right"
            @click="add"
            :class="{ disabled: searchForm.number >= 10 }"
          >
            <i class="el-icon-plus" />
          </div>
          <div class="item-label">每个知识点限1~10题</div>
        </div>
        <p class="control-content">
          共<span>{{ checkedWeakPointList.length }}</span
          >个知识点， 每个知识点推题<span>{{ searchForm.number }}</span
          >题， 总推送题目<span>{{ questionNum }}</span> 题，预计用时<span>{{
            Math.ceil(questionNum * 1.5)
          }}</span
          >分钟
        </p>
      </el-form-item>
      <el-form-item
        label="练习名称："
        required
        :class="errorProp === 'name' ? 'is-error' : ''"
      >
        <el-col :span="8">
          <el-input
            :placeholder="placeholderInfo"
            maxlength="30"
            v-model="searchForm.name"
          ></el-input>
        </el-col>
        <el-col
          style="margin-left: 10px; color: rgba(144, 147, 153, 1)"
          :span="10"
          >{{ searchForm.name.length }}/30</el-col
        >
      </el-form-item>
      <el-form-item label="练习对象：" required>
        <el-col :span="8">
          <el-cascader
            ref="cascader"
            :options="gradeList"
            style="width: 100%"
            separator=""
            :props="{
              multiple: true,
              value: 'dl_code',
              label: 'name',
              children: 'class_infos',
            }"
            v-model="searchForm.targets"
            popper-class="c-cascader"
            :class="errorProp === 'targets' ? 'is-error' : ''"
            @change="handleChange"

          >
            <template slot-scope="{ node, data }">
              <span>{{ data.name }}</span>
              <span
                v-if="!node.isLeaf && getSelectedCount(data.academic_year_id)"
                class="c-cascader__count"
              >
                {{ getSelectedCount(data.academic_year_id) }}
              </span>
            </template>
          </el-cascader>
        </el-col>
      </el-form-item>
      <el-form-item
        label="练习说明："
        required
        :class="errorProp === 'remark' ? 'is-error' : ''"
      >
        <el-col :span="14">
          <el-input
            type="textarea"
            v-model="searchForm.remark"
            placeholder="例如：本次练习共15题，预计用时18分钟"
          ></el-input>
        </el-col>
      </el-form-item>
    </el-form>
    <footer class="p-create__footer mt-40">
      <p
        class="p-create__error"
        :style="{ visibility: errorMessage ? 'visible' : 'hidden' }"
      >
        *{{ errorMessage }}
      </p>
      <el-button class="p-create__button" @click="onCancelClick"
        >取 消</el-button
      >
      <el-button type="primary" class="p-create__button" @click="onCreateClick"
        >创 建</el-button
      >
    </footer>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { createEvaluate, getTeacherClassYear, getLastInfo } from '@/api/pt';
import CardHeader from '@/components/card-header.vue';

export default {
  name: 'PublishWeakPoint',
  components: {
    CardHeader,
  },
  data() {
    return {
      exerciseType: this.$route.path.includes('exercise-type'),
      hwName: '',
      searchForm: {
        name: '', // 布置练习名称
        targets: '', // 布置班级列表
        remark: '',
        number: 3,
      },
      gradeList: [], // 练习年级列表
      formedTargets: '',
      questions: {},
      errorProp: '',
      loading: false,
    };
  },
  computed: {
    ...mapGetters([
      'commonWeakCourseInformation',
      'commonWeakCategoryObj',
      'checkedWeakPointList',
      'testInfo',
    ]),
    knowledgeCode() {
      const count = [];
      this.checkedWeakPointList.forEach((x) => {
        count.push(x.tag_code);
      });
      return count;
    },
    questionNum() {
      return this.checkedWeakPointList.length * this.searchForm.number;
    },
    errorMessage() {
      const map = {
        number: '请选择知识点',
        name: '请输入练习名称',
        remark: '请输入练习说明',
        targets: '请选择测评对象',
      };
      return `${map[this.errorProp] || ''}`;
    },
    placeholderInfo() {
      const myDate = new Date();
      let tMonth = myDate.getMonth() + 1;
      let tDay = myDate.getDate();
      tMonth = tMonth < 10 ? `0${tMonth}` : tMonth;
      tDay = tDay < 10 ? `0${tDay}` : tDay;
      const time = `${tMonth}${tDay}`;
      const name = `例如：${time}${this.commonWeakCategoryObj.subjectName}薄弱知识点训练`;
      return name;
    },
  },
  watch: {
    // 'searchForm.targets': function refinedTargets(v) {
    //   if (!v) {
    //     return;
    //   }
    //   this.$nextTick(() => {
    //     this.formedTargets = this.$refs.cascader.checkedNodes.map((item) => ({
    //       grade_id: item.path[0],
    //       class_id: item.path[1],
    //       class_name: item.pathLabels[1],
    //       school_year: item.pathLabels[0],
    //     }));
    //   });
    // },
  },
  methods: {
    handleChange() {
      this.$nextTick(() => {
        this.formedTargets = this.$refs.cascader.checkedNodes.map((item) => ({
          grade_id: item.path[0],
          class_id: item.path[1],
          class_name: item.pathLabels[1],
          school_year: item.pathLabels[0],
        }));
      });
    },
    // 查询最后一次作业的班级信息
    async queryLastInfo() {
      console.log('我查询???????????');
      await getLastInfo({
        type: 4,
      }).then((res) => {
        if (res.code === 200) {
          this.queryLastData = res.data;
          if (res.data.evaluate_object.length > 0) {
            const classList = [];
            res.data.evaluate_object.forEach((item) => {
              classList.push([String(item.grade_id), String(item.class_id)]);
            });
            this.searchForm.targets = classList;
            this.formedTargets = res.data.evaluate_object.map((item) => ({
              grade_id: item.grade_id,
              class_id: item.class_id,
              class_name: item.class_name,
              school_year: item.school_year,
            }));
          }
        }
      });
    },
    getTeacherClassYear() {
      return getTeacherClassYear().then((res) => {
        if (res.code === 200) {
          this.gradeList = res.data;
        }
      });
    },
    getSelectedCount(id) {
      if (!this.searchForm.targets) {
        return 0;
      }
      const len = this.$refs.cascader.checkedNodes
        .filter((item) => item.pathNodes[0].data.academic_year_id === id).length;
      return len;
    },
    onCancelClick() {
      this.$router.go(-1);
    },
    onCreateClick() {
      if (this.loading) {
        return;
      }
      if (this.checkForm()) {
        this.errorProp = '';
        this.loading = true;
        createEvaluate({
          evaluate_name: this.searchForm.name,
          remark: this.searchForm.remark,
          subject_id: this.commonWeakCategoryObj.subjectId,
          textbook_id: this.commonWeakCategoryObj.textbookId,
          test_grade_id: this.commonWeakCategoryObj.gradeId,
          course_id: this.commonWeakCourseInformation.courseId,
          course_name: this.commonWeakCourseInformation.courseName,
          app_id: 3,
          type: 4,
          is_sync: 1,
          evaluate_object: JSON.stringify(this.formedTargets),
          question_ids: JSON.stringify({
            knowledge_codes: this.knowledgeCode,
            question_num: this.searchForm.number,
          }),
          source_type: 3, // 正常布置1，薄弱知识点3
        }).then((res) => {
          if (res.code === 200) {
            console.log('创建成功');
            this.$router.push({
              path: '/pt/publish-success',
            });
          } else {
            this.$message({
              type: 'warning',
              message: res.msg,
            });
          }
        }).catch((e) => {
          console.log(e);
          this.$message({
            type: 'warning',
            message: e.msg,
          });
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    checkForm() {
      const keys = Object.keys(this.searchForm);
      return keys.every((key) => {
        if (this.searchForm[key]) {
          return true;
        }
        this.errorProp = key;
        return false;
      });
    },
    // 删除某个知识点
    handleClose(tag) {
      this.$set(tag, 'active', false);
      this.checkedWeakPointList.splice(this.checkedWeakPointList.indexOf(tag), 1);
    },
    // 出题数量的操作
    add() {
      if (this.searchForm.number >= 10) {
        return;
      }
      this.searchForm.number = this.searchForm.number * 1 + 1;
    },
    decrease() {
      if (this.searchForm.number <= 1) {
        return;
      }
      this.searchForm.number -= 1;
    },
  },
  created() {
    this.getTeacherClassYear();
    // 查询最后一次作业的班级信息
    this.queryLastInfo();
    this.searchForm.name = this.placeholderInfo;
  },
  activated() {
    this.getTeacherClassYear();
    // 查询最后一次作业的班级信息
    this.queryLastInfo();
    this.searchForm.name = this.placeholderInfo;
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-form-item .el-form-item__label {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
}
.knowledge-content /deep/ .el-form-item__label {
  float: none;
  padding: 0 12px 0 12px;
}
.knowledge-count /deep/ .el-form-item__label {
  float: none;
  padding: 0 12px 0 10px;
}
.knowledge-count {
  .control-number {
    display: flex;
    align-items: center;
    // margin-bottom: 16px;
    .btn {
      width: 40px;
      height: 40px;
      background: #f5f7fa;
      border-radius: 4px 0px 0px 4px;
      border: 1px solid #d8dce6;
      text-align: center;
      line-height: 40px;
      &.disabled {
        opacity: 0.5;
      }
      &.right {
        border-radius: 0px 4px 4px 0px;
      }
    }
    .item-label {
      margin-left: 16px;
      font-size: 14px;
    }
    .question-num-input {
      width: 73px;
      height: 40px;
      outline: none;
      padding: 0;
      border: 1px solid #dcdfe6;
      font-size: 14px;
      font-weight: 400;
      color: #606266;
      text-align: center;
    }
  }
  .control-content {
    font-size: 14px;
    span {
      color: #e6a23c;
    }
  }
}
.knowledge-name {
  width: 600px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  padding: 5px 12px 13px 0;
}
.knowledge-name /deep/ .el-tag {
  color: #5a5e66;
  background: #f0f2f5;
  margin-left: 12px;
  margin-top: 8px;
}
.p-create__error {
  color: rgba(245, 108, 108, 1);
  font-size: 14px;
  line-height: 2;
}
.p-create__footer {
  padding-left: 110px;
}
.p-create__button {
  width: 120px;
}
/deep/ .is-error .el-input__inner {
  border: 1px solid #f56c6c;
}
</style>
